import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import ListContainer from "../../../modules/company/containers/List";
import withPage from "../withPage";
import { PAGE_SIZE } from "../../../constants";
import PartnerCompanyForm from "../../Forms/Partners/Companies/Company";
import PartnerCompaniesTable from "../../Table/PartnerCompanies";
import "./Companies.scss";
import CompaniesFilterForm from "../../Forms/Filters/Companies";
import { getTranslation } from "../../../utils/helper";

const PartnerCompaniesPage = ({
  isFetching,
  companies,
  metadata,
  query,
  pushTo,
  doGetAllPartnerCompanies,
  doCreatePartnerCompany,
  doUpdatePartnerCompany,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [showFilters, setShowFilters] = useState(false);
  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} Companies`,
  };
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    company: null,
  });

  useEffect(() => {
    doGetAllPartnerCompanies({ currentPage, itemsPerPage, ...query });
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllPartnerCompanies({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    handleFilter(params, true);
  };

  const withAction = item => {
    return (
      <div className="actions">
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}>
          <ReactSVG className="icon" src="/icons/edit.svg" />
        </Button>
      </div>
    );
  };

  const handleClickAction = (action, item) => {
    setState({
      ...state,
      action,
      company: item,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    if (state.company) {
      await doUpdatePartnerCompany({
        id: state.company._id,
        ...values,
        password: values.password || null,
      });
    } else {
      await doCreatePartnerCompany(values);
      await doGetAllPartnerCompanies({ currentPage, itemsPerPage, ...query });
    }
    handleCancel();
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
    form.resetFields();
  };

  return (
    <div className="Content PartnerCompaniesPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">{getTranslation(setting, "Menu", "Companies")}</div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            <Button
              className={`FilterButton ${showFilters ? "Open" : "Close"}`}
              type="primary"
              onClick={() => setShowFilters(!showFilters)}>
              {getTranslation(setting, "Common", "Filter")}
              <ReactSVG className="icon" src="/icons/filter.svg" />
            </Button>
            <Button
              className="NewButton"
              type="primary"
              onClick={() => {
                handleClickAction("new", null);
              }}>
              {getTranslation(setting, "Companies", "New Sub Account")}
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
      </div>
      <div className="ContentFilters">
        {showFilters && (
          <CompaniesFilterForm isFetching={isFetching} query={query} onSubmit={handleFilter} setting={setting} />
        )}
      </div>
      <div className="ContentMain">
        <PartnerCompaniesTable
          rowKey="_id"
          query={query}
          withAction={withAction}
          loading={isFetching}
          pagination={pagination}
          dataSource={companies}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          actionWidth={50}
          setting={setting}
        />
      </div>
      <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={370}>
        <PartnerCompanyForm
          form={form}
          isFetching={isFetching}
          company={state.company}
          handleSubmit={handleOnFinish}
          handleCancel={handleCancel}
          setting={setting}
        />
      </Modal>
    </div>
  );
};

export default withPage(ListContainer(PartnerCompaniesPage));
